import { computed, observable, action } from 'mobx';

export class PrivacyStore {
  @observable _message$ = 'Um unsere Webseite für Sie optimal zu gestalten und fortlaufend verbessern zu können, verwenden wir Cookies. Durch die weitere Nutzung der Webseite stimmen Sie der Verwendung von Cookies zu. Weitere Informationen zu Cookies erhalten Sie in unserer';
  @observable _seen$ = false;

  constructor(storage = sessionStorage) {
    this.storage = storage;
    this.storageKey = 'privacy-message-read';
  }

  @action
  init() {
    if (this.storage) {
      this._seen$ = this.storage.getItem(this.storageKey) || false;
    } else {
      this._seen$ = false;
    }
  }

  @computed
  get message$() {
    if (this._seen$) { return null; }
    return this._message$;
  }

  @action.bound
  markRead() {
    if (this.storage) {
      sessionStorage.setItem(this.storageKey, true);
    }
    this._seen$ = true;
  }

  @action.bound
  markUnread() {
    if (this.storage) {
      sessionStorage.setItem(this.storageKey, false);
    }
    this._seen$ = false;
  }
}



// WEBPACK FOOTER //
// ./src/modules/privacy/privacy.store.js